//
// Generated class ProductFormat
//

/// <reference path="ProductFormat_ManagedObject.ts" />

class ProductFormat extends ProductFormat_ManagedObject
{
}
